import React from 'react'

import {
    useRouteMatch,
    //Link,
    Switch,
    Route,
    useHistory
} from 'react-router-dom'

import {
    Detail
} from './index'

import { setLoading, setfPic } from '../store/actions/picAction'
import { useDispatch, useSelector } from 'react-redux'

export default () => {
    const dispatch = useDispatch()
    const { fpics, loading } = useSelector(state => state.picReducer) 

    const {path, url} = useRouteMatch()
    const history = useHistory()
    function onClick(id){
        history.push(`${url}/${id}`)
    }

    function RemoveFav(id){
        setLoading(true)
        console.log(id,"....id in remove fav")
        const items = fpics.filter(fpic=>fpic.id!==id)
        dispatch(setfPic(items))
        setLoading(false)
        //console.log(fpics,"----removefav")
    }

    return (
        <>   
            <h4>Your Favourite Pictures are Here!</h4>
            {loading && <p>Loading ..... </p>}
            <div id="cardgroup">
                {fpics.map((pic, idx)=>(
                <div key={idx} id="card">
                    <button onClick={()=>onClick(pic.date)}>Detail</button>
                    <button onClick={()=>RemoveFav(pic.id)}>Remove</button>
                    <h3>{pic.title}</h3>
                    <p>{pic.date}</p>
                    <img src={ pic.url } alt="nasa" id="img-date"/>
                </div>
                ))}
            </div>
           
            <hr/>
            <Switch>
                <Route path={`${path}/:date`}>
                    <Detail/>
                </Route>
            </Switch>
        </>
    )
}